import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/keywords-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Keywords</title>
        <meta
          name='description'
          content='There are many things that you can do to boost your sales. To do that, you will have to make your Poshmark listings visible to potential buyers. Learn here the importance of keywords and how it can help your listings appear more on search results.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/keywords-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/keywords-poshmark' />
        <meta property='og:title' content='Poshmark Keywords' />
        <meta
          property='og:description'
          content='There are many things that you can do to boost your sales. To do that, you will have to make your Poshmark listings visible to potential buyers. Learn here the importance of keywords and how it can help your listings appear more on search results.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
